export const props = {
  label: [String, Number, Symbol, Boolean],
  disabled: Boolean,
  name: String
}
